export function getTitle() {
  if (window.location.hostname=='sis.buldreinfo.com') {
    return "SIS Buldring";
  } else if (window.location.hostname=='risa.buldreinfo.com') {
    return "Risa";
  } else if (window.location.hostname=='walid.buldreinfo.com') {
    return "Walid";
  } else {
    return "SIS Buldring";
  }
}

export function getHomeUrl() {
  if (window.location.hostname=='sis.buldreinfo.com') {
    return "https://sissportssenter.no/";
  } else if (window.location.hostname=='risa.buldreinfo.com') {
    return "https://risa.buldreinfo.com";
  } else if (window.location.hostname=='walid.buldreinfo.com') {
    return "https://walid.buldreinfo.com";
  } else {
    return "https://sissportssenter.no/";
  }
}

export function getSiteId() {
  if (window.location.hostname=='sis.buldreinfo.com') {
    return 3;
  } else if (window.location.hostname=='risa.buldreinfo.com') {
    return 4;
  } else if (window.location.hostname=='walid.buldreinfo.com') {
    return 5;
  } else {
    return 3;
  }
}

export function getMainColor() {
  if (window.location.hostname=='sis.buldreinfo.com') {
    return '#00a0e2';
  } else {
    return '#7796CB';
  }
}

export function getLogo() {
  if (window.location.hostname=='sis.buldreinfo.com') {
    return getMainColor() + ' url(/img/sis-sportssenter.png) center center no-repeat';
  } else {
    return getMainColor() + ' url(/img/home.png) center center no-repeat';
  }
}